const priceFormatter = (number) => {
  return Math.round(number)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const setDurations = (month) => {
  const durationsSelectWrapper = document.querySelector(
    ".product__calculator--select"
  );
  durationsSelectWrapper.innerHTML = "";
  month.forEach((month, index) => {
    const option = document.createElement("option");
    option.value = month.month;
    option.innerText = month.month;
    durationsSelectWrapper.append(option);
  });
};

const getPercentages = (plans, currentPlan) => {
  const planPercentages = plans
    .find((plan) => plan.title === currentPlan)
    .months_setup.map((month) => {
      return { [month.month]: month.margin_percent };
    });

  return planPercentages.reduce((acc, obj) => {
    const key = Object.keys(obj)[0]; // Assuming each object has only one key
    const value = obj[key];
    acc[key] = value;
    return acc;
  }, {});
};

const calculatePercentage = (part) => {
  let productPrice = document
    .querySelector(".amount")
    .innerText.replaceAll(" ", "")
    .replaceAll("сум", "");

  const discountedPrice = document
    .querySelector(".product-price-container .amount.discounted")
    ?.innerText.replaceAll(" ", "")
    .replaceAll("сум", "");
  productPrice = parseInt(discountedPrice || productPrice);

  const percentage = (parseInt(part) / parseInt(productPrice)) * 100;
  return Math.round(percentage);
};

const calculatePriceWithPercentage = (percentage) => {
  let productPrice = document
    .querySelector(".amount")
    .innerText.replaceAll(" ", "")
    .replaceAll("сум", "");

  const discountedPrice = document
    .querySelector(".product-price-container .amount.discounted")
    ?.innerText.replaceAll(" ", "")
    .replaceAll("сум", "");
  productPrice = parseInt(discountedPrice || productPrice);

  const part = (parseInt(percentage) / 100) * parseInt(productPrice);
  return Math.round(part);
};
